import React from "react";
import IconButton from '@material-ui/core/IconButton';
import NextArrow from "../../../../assets/buyers/nextArrow";

export const NextArrowButton = ({ handleClick }) => {
  return (
    <IconButton
    aria-label="more"
    aria-controls="long-menu"
    aria-haspopup="true"
    onClick={handleClick}
    >
      <NextArrow />
    </IconButton>
  )
}